import { render, staticRenderFns } from "./ReceivedReturn.vue?vue&type=template&id=b301ad62&"
import script from "./ReceivedReturn.vue?vue&type=script&lang=js&"
export * from "./ReceivedReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports